/* eslint-disable indent */
import axios from 'axios';
import { c2bOmsUrl } from '../constants/url-constants';
import getAccessToken from '../utils/helpers/get-access-token';

const DEBUG = process.env.NODE_ENV === 'development2';
let BASE_API_URL = c2bOmsUrl();
/* Create axios instance */
const api = axios.create({
    baseURL: BASE_API_URL,
    headers: {
        'Content-Type': 'application/json',
        X_VEHICLE_TYPE: 'CAR',
        X_COUNTRY: 'AE',
    },
});

// Request Interceptor which handles token refresh pre and post token expiry
api.interceptors.request.use((config) => {
    /** In dev, intercepts request and logs it into console for dev */
    const accessToken = getAccessToken();
    if (!config.headers['Authorization'] && accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    if (DEBUG) { console.info('✉️ ', config); }
    return config;
}, (error) => {
    if (DEBUG) { console.error('✉️ ', error); }
    return Promise.reject(error);
});

/**
 * Passes response.data to services.
 * In dev, intercepts response and logs it into console for dev
 */
api.interceptors.response.use((response) => {
    if (DEBUG) { console.info('📩 ', response); }
    return response;
}, (error) => {
    if (error.response && error.response.data) {
        if (DEBUG) { console.error('Error: ', error.response.data); }
        return Promise.reject(error.response.data);
    }
    if (DEBUG) { console.error('📩 ', error); }
    return Promise.reject(error.message);
});

export default api;
